import { WebPlugin } from '@capacitor/core';
export class NotificarePluginWeb extends WebPlugin {
    //
    // Core
    //
    isConfigured() {
        throw this.unimplemented('Not implemented on web.');
    }
    isReady() {
        throw this.unimplemented('Not implemented on web.');
    }
    launch() {
        throw this.unimplemented('Not implemented on web.');
    }
    unlaunch() {
        throw this.unimplemented('Not implemented on web.');
    }
    getApplication() {
        throw this.unimplemented('Not implemented on web.');
    }
    fetchApplication() {
        throw this.unimplemented('Not implemented on web.');
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    fetchNotification(_options) {
        throw this.unimplemented('Not implemented on web.');
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    fetchDynamicLink(_options) {
        throw this.unimplemented('Not implemented on web.');
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    canEvaluateDeferredLink() {
        throw this.unimplemented('Not implemented on web.');
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    evaluateDeferredLink() {
        throw this.unimplemented('Not implemented on web.');
    }
    //
    // Device module
    //
    getCurrentDevice() {
        throw this.unimplemented('Not implemented on web.');
    }
    getPreferredLanguage() {
        throw this.unimplemented('Not implemented on web.');
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updatePreferredLanguage(_options) {
        throw this.unimplemented('Not implemented on web.');
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    register(_options) {
        throw this.unimplemented('Not implemented on web.');
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updateUser(_options) {
        throw this.unimplemented('Not implemented on web.');
    }
    fetchTags() {
        throw this.unimplemented('Not implemented on web.');
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    addTag(_options) {
        throw this.unimplemented('Not implemented on web.');
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    addTags(_options) {
        throw this.unimplemented('Not implemented on web.');
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    removeTag(_options) {
        throw this.unimplemented('Not implemented on web.');
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    removeTags(_options) {
        throw this.unimplemented('Not implemented on web.');
    }
    clearTags() {
        throw this.unimplemented('Not implemented on web.');
    }
    fetchDoNotDisturb() {
        throw this.unimplemented('Not implemented on web.');
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updateDoNotDisturb(_options) {
        throw this.unimplemented('Not implemented on web.');
    }
    clearDoNotDisturb() {
        throw this.unimplemented('Not implemented on web.');
    }
    fetchUserData() {
        throw this.unimplemented('Not implemented on web.');
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updateUserData(_options) {
        throw this.unimplemented('Not implemented on web.');
    }
    //
    // Events
    //
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    logCustom(_options) {
        throw this.unimplemented('Not implemented on web.');
    }
}
//# sourceMappingURL=web.js.map